export const AUTH_TOKEN = "auth_token";
export const AUTH_STORAGE = "auth_persistence";
export const USER_ID = "userId";
export const USER_NAME = "username";
export const AUTH_USER = "auth_user";
